import { type FunctionalComponent, h } from '@stencil/core';
import type { GuidedItemBase } from '../api';
import { QuickLink } from './quick-link';
import { QuickOrderLink } from './quick-order-link';
import { QuickQuoteLink } from './quick-quote-link';


export interface QuickLinksProps{
  sections: String, //json string for array
  quicklinks:Array<GuidedItemBase>,
  labelProvider: CallableFunction,
  clickHandler: CallableFunction,
  titlesOff: boolean,
}

export const QuickLinks:FunctionalComponent<QuickLinksProps> = (props) => {

    const { sections, quicklinks, labelProvider, clickHandler, titlesOff } = props;

    const quickLinksRendered = sections
      .split(',')
      .map(i => i.trim())
      .map(section => {

          const linksInSection = quicklinks
            .filter(link => link.sectionId == section);

          if (linksInSection.length == 0)
            return '';

          //note: labelProvider can return empty string as label for 'section', then it triggers the ternary clause.
          //      If the label doesn't exist (is undefined), the raw section name will be used

          const getQuickLink = (item)=>{
              switch(section) {
              case 'orders':
                return <QuickOrderLink guidedlinkitem={item}
                  clickHandler={clickHandler} labelProvider={labelProvider}></QuickOrderLink>;
              case 'quotes':
                return <QuickQuoteLink guidedlinkitem={item}
                  clickHandler={clickHandler} labelProvider={labelProvider}></QuickQuoteLink>;
              default:
                return <QuickLink
                  guidedlinkitem={item}
                  clickHandler={clickHandler}
                ></QuickLink>;
              }
          };


          return <div class="guided-pane__quick-links-section">

            {labelProvider(section, section) !== '' || !titlesOff ? //Check note above
              <div class="guided-pane__quick-links-section-label">
                {labelProvider(section, (linksInSection[0]['section'] || section))}
              </div> : ''

            }
            <ul class="guided-pane__quick-links-list">
              {linksInSection.map(getQuickLink)}
            </ul>
          </div>;
      });

    if (quickLinksRendered.length == 0)
      return '';

    const label = labelProvider('search-for-quick-links', 'Quick Links');

    return <div class="guided-pane__quick-links">

      {label && !titlesOff ? <p class="guided-pane__quick-links-toplabel">
        {label}
      </p>
        : ''}

      {quickLinksRendered}

    </div>;
};
